import { Chip, Select, SwitchButton } from "@ui";
import cn from "classnames";
import style from "./AutoContinueCell.module.scss";
import { IProxy } from "@interfaces/user/proxy";
import { useUpdateAutoContinueStatusMutation, useUpdateDaysForContinueMutation } from "@RTKQuery/user/purchases/purchases";
import { RiLoader5Fill } from "react-icons/ri";
import { useAppSelector } from "store/hooks";
import { useState } from "react";

export function AutoContinueCell({
    data
}: {
    data: IProxy
}) {
    const { activePaginationLimit, activePaginationPage, activeSearchParameter, activeTags } = useAppSelector(state => state.myProxiesUserPage)

    const [updateAutoContinueStatus, updateAutoContinueStatusStatus] = useUpdateAutoContinueStatusMutation();
    const [updateDaysForContinue, updateDaysForContinueStatus] = useUpdateDaysForContinueMutation();

    const [daysForContinue, setDaysForContinue] = useState<number | null>(data.days_for_continue)

    return (
        <div className={cn(style.cell, "justify-self-center gap-[5px]")}>
            <SwitchButton
                checked={data.auto_continue}
                onChecked={() => {
                    updateAutoContinueStatus({
                        purchase_id: data.id,
                        auto_continue: !data.auto_continue,
                        params: {
                            limit: activePaginationLimit,
                            page: activePaginationPage,
                            search: activeSearchParameter,
                            tag_ids: activeTags
                        }
                    })
                }}
                size="big"
                disabled={daysForContinue === null}
            />
            <Select
                currentValue={{
                    label: daysForContinue ? String(daysForContinue) + (daysForContinue === 3 ? " дня" : " днів") : 'Не вибрано',
                    value: String(daysForContinue)
                }}
                onChange={(value) => {
                    setDaysForContinue(Number(value.value));
                    updateDaysForContinue({
                        purchase_id: data.id,
                        days_for_continue: Number(value.value),
                        params: {
                            limit: activePaginationLimit,
                            page: activePaginationPage,
                            search: activeSearchParameter,
                            tag_ids: activeTags
                        }
                    })
                }}
                listValues={[
                    {
                        label: "3 дня",
                        value: "3"
                    },
                    {
                        label: "7 днів",
                        value: "7"
                    },
                    {
                        label: "30 днів",
                        value: "30"
                    },
                    {
                        label: "90 днів",
                        value: "90"
                    }
                ]}
            />
            {
                updateAutoContinueStatusStatus.isError || updateDaysForContinueStatus.isError
                    ? <div className={style.status}>
                        <Chip
                            text="Помилка"
                            color="red"
                        />
                    </div>

                    : null
            }
            {
                updateAutoContinueStatusStatus.isLoading || updateDaysForContinueStatus.isLoading
                    ?
                    <div className={style.status}>
                        <RiLoader5Fill className={"animate-spin"} />
                    </div>
                    : null
            }

        </div>
    )
}